<div *ngIf="claimDto!.isLocked" class="text-center">
  <label class="d-block form-label text-uppercase lh-md mb-1" [ngClass]="{'mt-n1px': !minimalUi}">
    Authorization Number
  </label>
  <button
    class="btn btn-link fs-2 fw-bolder text-uppercase text-nowrap lh-md"
    [ngClass]="minimalUi ? 'pb-1 pt-0' : 'mt-2px py-0'"
    (click)="viewClaimInE2()"
  >
    {{ claimDto!.authorizationNumber }}
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
         stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
         class="feather feather-external-link">
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
      <polyline points="15 3 21 3 21 9"></polyline>
      <line x1="10" y1="14" x2="21" y2="3"></line>
    </svg>
  </button>
</div>

<fieldset *ngIf="!claimDto!.isLocked">
  <label class="form-label mb-0 lh-sm">Authorization Number</label>
  <div class="input-group">
    <input
      class="form-control"
      type="text"
      [(ngModel)]="claimDto!.authorizationNumber"
      (keyup)="updateClaimAuthorizationNumber()"
    >
    <button
      *ngIf="isValidAuthorizationNumber()"
      class="btn btn-outline-primary btn-bg-white"
      (click)="viewClaimInE2()"
      ngbTooltip="View Claim in E2"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
           class="feather feather-external-link">
        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
        <polyline points="15 3 21 3 21 9"></polyline>
        <line x1="10" y1="14" x2="21" y2="3"></line>
      </svg>
    </button>
    <button
      *ngIf="!claimDto!.authorizationNumber"
      class="btn btn-outline-primary btn-bg-white"
      (click)="pushClaimToE2()"
    >
      <span
        [ngClass]="isSubmitting ? 'show' : ''"
        class="spinner fade spinner-border spinner-border-sm position-absolute top-0 bottom-0 start-0 end-0 m-auto"
        role="status" aria-hidden="true"></span>
      <span [ngClass]="isSubmitting ? '' : 'show'" class="text fade">Push to E2</span>
    </button>
  </div>
</fieldset>
